import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { SimulationService, LeadInsertPayload } from '../../../services/simulation.service';
import { LeadsDetailsService } from '../../../services/leads-details-service.service';
import { LocalStorageUtil } from '../../../utils/local-storage.util';

@Component({
  selector: 'app-integration-digital-lead-simulation',
  standalone: true,
  template: ''
})
export class LeadSimulationDigitalIntegration implements OnInit {

  constructor(
    private leadsDetailsService: LeadsDetailsService,
    private route: ActivatedRoute,
    private simulationService: SimulationService,
    private router: Router,
    private location: Location) {}
  
  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      const token = params.get('token');
      const idSimulacao = params.get('idSimulacao');
      const leadId = params.get('idLead');

      if (!leadId) {
        console.error('❌ Parâmetro idLead é obrigatório');
        this.router.navigate(['/error'], {
          state: {message: 'Parâmetro idLead é obrigatório'}
        });
        return;
      }

      // Remove token da URL imediatamente (mitigação RIS 180/179 - session token in URL)
      this.location.replaceState(this.router.url.split('?')[0] || '/lead-simulation');

      this.leadsDetailsService.getLeadDetails(leadId).subscribe({
        next: (details) => {
          LocalStorageUtil.setSelectedVWDn(details.dn);

          this.simulationService.GetAndUpdateSimulation(idSimulacao, leadId, token).subscribe({
            next: (simulationData) => {
              // Verificar se é necessário criar lead com Renova+
              // Nota: A lógica exata depende de como o backend funciona
              // Se o lead já existe, apenas navegar
              // Se precisa criar, usar inserirLeadComRenovaPlus
              
              this.router.navigate(['leads', leadId, 'leads-offers']);
            },
            error: (error) => {
              // Evitar logs com possíveis dados sensíveis (token/CPF/CNPJ) em ambiente bancário
            }
          });

        },
        error: (error) => {
          console.error('❌ Erro ao carregar detalhes do lead:', error);
          this.router.navigate(['/error'], {
            state: {message: error.message || 'Erro na comunicação com o sistema'}
          });
        }
      });      

    });
  }
  
}
